
<template>
    <!-- 门店设备管理 -->
    <div>
        <el-form :inline="true" class="form" label-width="100px" :model="searchForm">
            <el-form-item label="设备编码">
                <el-input v-model="searchForm.cnNum" maxlength="36" placeholder="请输入设备编码" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="设备类型">
                <el-select v-model="searchForm.hardwareStoreTpye" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="义诊设备" value="1"></el-option>
                    <el-option label="会员设备" value="0"></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item>
                <el-button type="primary" v-debounce="onSearch">查询</el-button>
            </el-form-item>

            <el-form-item>
                <el-button size="mini" class="add_btn" type="success" @click="handleAddEquipment">+新增</el-button>
            </el-form-item>

        </el-form>
        <!-- <el-button type="success" class="add">新增</el-button> -->
        <el-card class="box-card" shadow="never">
            <el-table :data="orderData" style="width: 100%" v-loading="loading">
                <!-- <el-table-column type="index" label="序号" width="50" align="center" /> -->
                <!-- <el-table-column prop="memberName" label="vip用户" align="center" /> -->
                <!-- <el-table-column prop="storeName" label="归属门店" align="center" /> -->
                <el-table-column prop="hardwareType" width="200" label="设备名称" align="center">
                    <template slot-scope="{row}">
                        <!-- 硬件设备类型(1-药康夫智能血糖仪 2-药康夫智能血压计 3-药康夫智能血糖血压一体机 ) -->
                        <el-tag>{{formatEquipmentDate(row.hardwareType)}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="hardwareSn" label="设备S/N" align="center" />
                <el-table-column prop="hardwareModel" label="设备型号" align="center" />
                <el-table-column prop="hardwareType" label="设备类型" align="center">
                    <template slot-scope="scope">
                        <el-tag>{{scope.row.hardwareStoreTpye == 0 ? '会员设备':'义诊设备'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="{row}">
                        <el-button type="text" @click="deleteEquipment(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <div class="pager">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="searchForm.pageNum" :total="total" @current-change="onChangeCurrent" @size-change="onChangeSize" :page-sizes="[10, 20, 30, 40]" :page-size="10">
            </el-pagination>
        </div>
        <!-- 新增设备弹框 -->
        <el-dialog title="新增设备" center :visible.sync="showList" width="950px" top="3vh" class="abow_dialog" :before-close="handleBeforeClose">
            <el-form :inline="true" class="form" label-width="560px" :model="addSearchForm" :rules="addRules" ref="addSearchForm">
                <el-form-item label="设备编码" prop="hardwareSn">
                    <div style="display:flex " class="example1">
                        <el-input v-model="addSearchForm.hardwareSn" maxlength="36" placeholder="请输入设备编码"></el-input>
                        <el-tooltip content="请输入正确的设备编号进行查询" placement="top">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onAddSearch('addSearchForm')">查询</el-button>
                </el-form-item>
            </el-form>
            <el-card class="box-card" shadow="never">
                <el-table :data="addOrderData" style="width: 100%" v-loading="loading" height="480" ref="multipleTable">
                    <el-table-column prop="hardwareType" width="200" label="设备名称" align="center">
                        <template slot-scope="{row}">
                            <!-- 硬件设备类型(1-药康夫智能血糖仪 2-药康夫智能血压计 3-药康夫智能血糖血压一体机 ) -->
                            <el-tag>{{formatEquipmentDate(row.hardwareType)}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="hardwareSn" label="设备S/N" align="center" />
                    <el-table-column prop="hardwareModel" label="设备型号" align="center" />
                    <el-table-column prop="hardwareType" label="设备类型" align="center">
                        <template slot-scope="scope">
                            <el-tag>{{scope.row.hardwareStoreTpye == 0 ? '会员设备':'义诊设备'}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="bindStatus" label="是否可绑" align="center">
                        <template slot-scope="scope">
                            {{scope.row.bindStatus ==1 ?"是":"否"}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="notBindReason" label="不可绑定原因" align="center">
                        <template slot-scope="scope">
                            {{scope.row.notBindReason}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200" align="center">
                        <template slot-scope="{row}">
                            <el-button :disabled="row.bindStatus==2?true:false" type="text" @click="upDate(row)">新增</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <div class="pager">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="addSearchForm.pageNum" :total="addTotal" @current-change="onChangeCurrent" @size-change="onChangeSize" :page-sizes="[10, 20, 30, 40]" :page-size="10">
                </el-pagination>
            </div>
            <!-- 弹窗底部
            <div slot="footer" class="dialog-footer dialog_foot">
                <div>
                    <el-button @click="showList = false">取 消</el-button>
                    <el-button type="primary" @click="upDate">新增</el-button>
                </div>
            </div> -->
        </el-dialog>
    </div>
</template>
<script>
import { hardwareList, unbindHardwareBySystem } from '@/api/system/operation'
import { formatDate } from '@/utils/index';
import { getEquipment, getEquipmentData, getEquipmentById, getEquipmentDetailData, addEquipment, deleteEquipment } from "@/api/ykfApi/request";
import { log } from 'util';

export default {
    data() {
        var snVail = (rule, value, callback) => {
            if ((value == '')) {
                callback(new Error('请输入设备编号'));
            } else if (value) {
                var reg = /^[0-9]{2}[A-Z]{1}[0-9]{6}$/g;
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error('设备编号格式不正确'));
                }
            }
        };
        return {
            searchForm: {
                pageSize: 10,
                pageNum: 1,
                // storeId: localStorage.getItem("ms_user_manage_data").id,
                storeId: JSON.parse(localStorage.getItem("loginData")).storeId || "",
                enterpriseId: JSON.parse(localStorage.getItem("loginData")).enterpriseId,
                memberName: '',
                canDelete: '',
                hardwareNumber: '',
                hardwareStoreTpye: '',
                hardwareType: '',
                cnNum: "",

            },
            addRules: {
                hardwareSn: [
                    { validator: snVail, trigger: 'blur' },
                ]
            },
            addSearchForm: {
                pageSize: 10,
                pageNum: 1,
                memberName: '',
                canDelete: '',
                hardwareNumber: '',
                hardwareStoreTpye: "1",
                hardwareType: '',
                hardwareSn: ''
            },

            stroeId: JSON.parse(localStorage.getItem("loginData")).storeId,
            enterpriseId: JSON.parse(localStorage.getItem("enterpriseInfo")).id || "",
            showList: false,
            date: [],
            orderData: [],
            addOrderData: [],
            total: 0,
            addTotal: 0,
            loading: false,
            equipmentDetailData: []
        }
    },
    created() {
        this.onList();
        this.getEquipmentDetailData()
        // getEquipmentById(this.searchForm)
        // this.getEquipment(this.searchForm);
    },
    methods: {
        handleBeforeClose() {
            this.$refs.addSearchForm.resetFields();
            this.addSearchForm.hardwareSn = "";
            // this.onAddList();
            this.showList = false;
        },
        // 删除设备
        deleteEquipment({ id }) {
            console.log(id, typeof id);
            deleteEquipment({ cnId: id }).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.onList();
                }

            })
        },

        // 处理新增选择
        handleSelectionChange(val) {
            console.log(val);
            let id = val.map(item => item.id)
            this.addEquipmentQuery.cnId = id;
        },
        // 提交数据
        upDate({ id }) {
            let data = { stroeId: this.stroeId, cnId: id, enterpriseId: this.enterpriseId }
            // if (localStorage.getItem('enterpriseType') == '1') {
            //     data = { cnId: id, enterpriseId: this.enterpriseId }
            // }
            addEquipment(data).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '您已成功增加了一台设备',
                        type: 'success'
                    });
                    this.onAddList();
                    this.onList();
                }
            })
        },
        // 查询设备
        getEquipment(data) {
            return getEquipment(data);
        },
        // 查询门店设备
        getStoreEquipment(data) {
            return getEquipmentById(data);
        },
        // 设备解绑
        handleUnbindHardwareBySystem(id) {
            unbindHardwareBySystem({ id }).then(res => {
                this.$message.success('操作成功')
                this.onList()
            })
        },
        switching({ id, hardwareStoreTpye }) {
            const h = this.$createElement;
            this.$msgbox({
                title: '设备类型切换',
                message: h('p', null, [
                    h('span', { style: 'color: #5a5a5a' }, '确认切换此设备的类型吗?')
                ]),
                showCancelButton: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(async action => {
                await equipmentTypeSwitching({ id, type: hardwareStoreTpye == 1 ? 0 : 1 });
                console.log(hardwareStoreTpye == 1);
                this.$message.success(`成功将此设备切换为${hardwareStoreTpye == 1 ? "会员设备" : "义诊设备"}`)
                this.onList();
            }).catch(() => {
            })
        },
        onList() {
            this.loading = true;

            this.getStoreEquipment(this.searchForm).then(res => {
                if (res.code == 200) {
                    this.orderData = res.data.rows;
                    this.total = res.data.total;
                    this.loading = false;
                }
            })
        },
        onAddList() {
            this.loading = true;
            this.getEquipment(this.addSearchForm).then(res => {
                if (res.code == 200) {
                    this.addOrderData = res.data.rows;
                    this.addTotal = res.data.total;
                    this.loading = false;
                }
            })
        },
        // 新增设备
        handleAddEquipment() {
            this.showList = true;
        },
        // 搜索
        onSearch() {
            this.searchForm.pageNum = 1;
            this.onList();
        },
        onAddSearch(addSearchForm) {
            let _this = this;
            _this.$refs[addSearchForm].validate((valid) => {
                if (valid) {
                    this.addSearchForm.pageNum = 1;
                    this.onAddList();
                }
            })
        },
        // 重置
        reset() {
            this.searchForm = {
                pageSize: 10,
                pageNum: 1,
                memberName: '',
                canDelete: '',
                hardwareNumber: ''
            }
            this.date = '';
            this.onList();
        },
        // 设备详细数据
        getEquipmentDetailData() {
            return getEquipmentData().then(res => this.equipmentDetailData = res.data);
        },
        formatEquipmentDate(args) {
            switch (args) {
                case 1: return this.equipmentDetailData[0].hardwareName;
                    break;
                case 2: return this.equipmentDetailData[1].hardwareName;
                    break;
                case 3: return "药康夫智能血糖血压一体机";
                    break;

            }
        },
        /**
   * 格式化时间
   */
        formatDate(dateTime) {
            // debugger
            let date = new Date(dateTime);
            var myyear = date.getFullYear();
            var mymonth = date.getMonth() + 1;
            var myweekday = date.getDate();

            if (mymonth < 10) {
                mymonth = "0" + mymonth;
            }
            if (myweekday < 10) {
                myweekday = "0" + myweekday;
            }
            //console.log(myyear + "-" + mymonth + "-" + myweekday)
            return myyear + "-" + mymonth + "-" + myweekday;
        },
        onChangeCurrent(val) {
            this.searchForm.pageNum = val;
            this.onList();
            //console.log('页', val);
        },
        onChangeSize(val) {
            this.searchForm.pageNum = 1
            this.searchForm.pageSize = val;
            this.onList();
        },

    },
    filters: {
        // formatEquipmentDate(args) {
        //     console.log(args);
        //     switch (args) {
        //         case 1: this.equipmentDetailData[0].hardwareName;
        //             break;
        //         case 2: this.equipmentDetailData[1].hardwareName;
        //             break;
        //     }
        // }
    }
}
</script>
<style scoped lang="less">
.box-card ::v-deep .el-card__header {
    padding-left: 20px;
}
.form {
    margin: 20px;
}
.pager {
    text-align: right;
    margin: 30px;
}
.text {
    margin-right: 20px;
}
.btn {
    width: 50%;
    margin-top: 40px;
    text-align: center;
}
.btn button:first-child {
    margin-right: 30px;
}
.detail {
    width: 100%;
    margin-left: 100px;
    li {
        list-style: none;
        margin-bottom: 20px;
        // justify-content: center;
        display: flex;
        > p:nth-child(1) {
            width: 100px;
            //   font-size: 20px;
        }
    }
}
.abow_dialog /deep/ .el-dialog__footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 0;
    background: #fff;
}
.add {
    margin-left: 40px;
    margin-bottom: 10px;
}
.example1 {
    cursor: pointer;
    /deep/ i {
        font-size: 20px;
        line-height: 20px;
        // vertical-align: -5px;
        margin: 5px 0 0 2px;
        display: inline-block;
    }
    .el-icon-question {
        // font-size: 30px;
    }
}
/deep/ .el-card {
    border: 0;
}
</style>


